import { Component, h } from '@stencil/core';

@Component({
  tag: 'utrecht-icon-overlijden',
  styleUrl: "../../icon/generated.scss",
  shadow: true,
})
export class UtrechtIconOverlijden {

  render() {
    return (
      <svg viewBox="0 0 36 36" xmlns="http://www.w3.org/2000/svg" fill="currentColor" height="1em" width="1em">
  <path d="M17 14.89c0-.36-.19-.71-.51-.88-4.35-2.4-9.63-2.4-13.98 0-.32.17-.51.52-.51.88V27h15zM12 22c0 .55-.45 1-1 1H8c-.55 0-1-.45-1-1s.45-1 1-1h3c.55 0 1 .45 1 1m2-3.99c0 .55-.45 1-1 1H6c-.55 0-1-.45-1-1s.45-1 1-1h7c.55 0 1 .45 1 1m22 2.91c0 .72-.73 1.18-1.39.9C30.04 19.9 25.16 19 20.21 19c-.4 0-.81 0-1.21.02v-2c3.1-.09 6.11.17 9 .74v-2.75h-1.18c-1.65-.11-2.92-1.63-2.82-3.4.01-.19.04-.37.08-.56-1.27-1.14-1.45-3.16-.39-4.53.2-.25.43-.47.69-.65-.81-1.55-.3-3.51 1.14-4.38.46-.28.97-.41 1.48-.41C27.46.43 28.18 0 29 0s1.54.43 2 1.09c.82 0 1.65.35 2.24 1.06.85 1.02 1.01 2.52.38 3.72 1.4.96 1.81 2.94.91 4.44-.17.28-.37.53-.61.74.38 1.73-.61 3.46-2.22 3.87-.23.06-.46.09-.7.09h-1v3.2c1.85.47 3.65 1.06 5.39 1.8.37.16.61.52.61.92ZM19 31v1H0v-1c0-1.1.9-2 2-2h15c1.1 0 2 .9 2 2m16.39 3.58a.996.996 0 0 1-.9 1.42h-.05c-.38 0-.73-.23-.89-.57-1.96-4.16-5.2-7.72-9.27-10.1-1.66-.97-3.44-1.71-5.28-2.22v-2.1c2.17.55 4.28 1.41 6.28 2.58 4.41 2.58 7.96 6.43 10.1 11Z"/>
</svg>

    );
  }
}
